import ServiceBase from '../ServiceBase';

export default class BannerService extends ServiceBase {

    getProjectAdverts(projectID, pageSize, pageIndex) {
        return this.request('get', 'admin/banner/getProjectAdverts', {
            projectID,
            pageSize,
            pageIndex,
        });
    }

    getProjectAdvert(projectAdvertID) {
        return this.request('get', 'admin/banner/getProjectAdvert', {
            projectAdvertID,
        });
    }

    deleteProjectAdvert(projectAdvertID) {
        return this.request('post', 'admin/banner/deleteProjectAdvert', {
            projectAdvertID,
        });
    }

    createProjectAdvert(projectAdvert) {
        return this.request('post', 'admin/banner/createProjectAdvert', {
            ...projectAdvert,
        });
    }

    updateProjectAdvert(projectAdvert) {
        return this.request('post', 'admin/banner/updateProjectAdvert', {
            ...projectAdvert,
        });
    }

    getInfoBanners() {
        return this.request('get', 'admin/banner/getInfoBanners');
    }

    getInfoBanner(infoBannerID) {
        return this.request('get', 'admin/banner/getInfoBanner', {
            infoBannerID,
        });
    }

    deleteInfoBanner(infoBannerID) {
        return this.request('post', 'admin/banner/deleteInfoBanner', {
            infoBannerID,
        });
    }

    addInfoBanner(infoBanner) {
        return this.request('post', 'admin/banner/addInfoBanner', {
            ...infoBanner,
        });
    }

    updateInfoBanner(infoBanner) {
        return this.request('post', 'admin/banner/updateInfoBanner', {
            ...infoBanner,
        });
    }

    duplicateInfoBanner(infoBannerID) {
        return this.request('post', 'admin/banner/duplicateInfoBanner', {
            infoBannerID,
        });
    }

    reorderInfoBanners({ infoBannerID, sortOrder }) {
        return this.request('post', 'admin/banner/reorderInfoBanners', {
            infoBannerID,
            sortOrder,
        });
    }

    getHeroBanners(params) {
        return this.request('post', 'admin/banner/getHeroBanners', params);
    }

    getHeroBanner(heroBannerID) {
        return this.request('get', 'admin/banner/getHeroBanner', {
            heroBannerID,
        });
    }

    deleteHeroBanner(heroBannerID) {
        return this.request('post', 'admin/banner/deleteHeroBanner', {
            heroBannerID,
        });
    }

    addHeroBanner(heroBanner) {
        return this.request('post', 'admin/banner/addHeroBanner', {
            ...heroBanner,
        });
    }

    updateHeroBanner(heroBanner) {
        return this.request('post', 'admin/banner/updateHeroBanner', {
            ...heroBanner,
        });
    }

    reorderHeroBanners({ heroBannerID, sortOrder }) {
        return this.request('post', 'admin/banner/reorderHeroBanners', {
            heroBannerID,
            sortOrder,
        });
    }
}
